import { useT } from '@planetra/i18n';
import { Button, EmptyState } from '@planetra/ui';
import { MapPinOff } from 'lucide-react';
import { Link } from 'react-router';
import { ROUTES } from '../app/routes';

/**
 * 404. Rendered both by the catch-all route and by the route error boundary
 * when a loader throws a 404 response, so the two cannot drift apart.
 *
 * An `EmptyState`, not a `Callout` — nothing failed, the thing asked for is
 * simply not there.
 */
export function NotFound() {
  const { t } = useT();

  return (
    <EmptyState
      icon={MapPinOff}
      title={t('errors:notFound.title')}
      description={t('errors:notFound.description')}
      action={
        <Button asChild variant="secondary" size="sm">
          <Link to={ROUTES.root}>{t('common:actions.goToProjects')}</Link>
        </Button>
      }
    />
  );
}
